import { getDescriptionMaxLengthError, validateGCompanyField } from '@opportunities/-lib/opportunityValidation'
import { useMemo } from 'react'
import { getVisibleErrors } from '@/lib/form-validation'
import type { OpportunityStatusState } from '../-components/OpportunityStatusSelect'

interface UseOpportunityStatusValidationParams {
  statusState: OpportunityStatusState
  touched: Record<string, boolean>
  isClosed: boolean
  isGCompanyFlow: boolean
  isAdditionalCloseReasonRequired: boolean
}

export function useOpportunityStatusValidation({
  statusState,
  touched,
  isClosed,
  isGCompanyFlow,
  isAdditionalCloseReasonRequired,
}: UseOpportunityStatusValidationParams) {
  const allStatusErrors = useMemo(() => {
    const errors: Record<string, string> = {}

    if (isClosed && !statusState.closeReasonId) {
      errors.closeReason = 'クローズ理由は必須です'
    }

    if (isAdditionalCloseReasonRequired) {
      const maxLengthError = getDescriptionMaxLengthError(statusState.additionalCloseReason)
      if (maxLengthError) {
        errors.additionalCloseReason = maxLengthError
      } else if (!statusState.additionalCloseReason.trim()) {
        errors.additionalCloseReason = 'クローズ理由（詳細）は必須です'
      }
    }

    if (isGCompanyFlow) {
      const gNameError = validateGCompanyField(statusState.gCompanyName)
      if (gNameError) errors.gCompanyName = gNameError
      const gContactError = validateGCompanyField(statusState.gCompanyContact)
      if (gContactError) errors.gCompanyContact = gContactError
    }

    return errors
  }, [
    isClosed,
    statusState.closeReasonId,
    isAdditionalCloseReasonRequired,
    statusState.additionalCloseReason,
    isGCompanyFlow,
    statusState.gCompanyName,
    statusState.gCompanyContact,
  ])

  // 表示用エラー（touched なフィールドのみ）
  const statusErrors = getVisibleErrors(allStatusErrors, touched)

  const hasAllStatusErrors = Object.keys(allStatusErrors).length > 0

  return {
    statusErrors,
    hasAllStatusErrors,
  }
}
